import styled, {css} from "styled-components";
import {CssRule} from "../../../../../../../../../themes/architecture/css-helpers/css-rule";

function renderCorner(cornerImageUrl: string) {
    return css`
      content: "";
      background-image: url("${cornerImageUrl}");
      background-repeat: no-repeat;
      background-size: 78px 51px ;
      width: 77px;
      margin: 0;
      ${CssRule.For.RTL.build()} & {
        transform: scaleX(-1);
      }
    `
}

export const GamePlayPcHeaderBarTopMiddleSectionContentBox = styled.div<{leftCornerImageUrl: string; rightCornerImageUrl: string}>`
    display: flex;
    flex-direction: row;
    height: 50px;
    margin: 1px 0 0 0;
    &:before {
      ${props => renderCorner(props.leftCornerImageUrl)}
        margin-right: -1px; 
    }
  
    &:after {
      ${props => renderCorner(props.rightCornerImageUrl)}
      margin-left: -1px;
    }
`